var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNight = function SvgNight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333374,
    width: 16,
    height: 16,
    rx: 4,
    fill: "url(#paint0_linear_872_7588)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_872_7588",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 13,
    height: 12
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.33337,
    y: 2,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_872_7588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.34777 12.2501C7.16316 12.2501 6.15867 11.8379 5.33432 11.0135C4.50996 10.1892 4.09778 9.1847 4.09778 8.00009C4.09778 7.01356 4.40306 6.13665 5.01363 5.36935C5.62419 4.60204 6.43749 4.10749 7.4535 3.88569C7.65543 3.83505 7.81232 3.88441 7.92418 4.03376C8.03604 4.18312 8.04549 4.34722 7.95254 4.52606C7.84934 4.71388 7.77274 4.90939 7.72274 5.1126C7.67274 5.3158 7.64774 5.5283 7.64774 5.75009C7.64774 6.57061 7.93428 7.26741 8.50737 7.84049C9.08045 8.41356 9.77725 8.7001 10.5978 8.7001C10.8433 8.7001 11.0779 8.66901 11.3016 8.60684C11.5253 8.54466 11.7212 8.47255 11.8891 8.3905C12.0481 8.31871 12.1952 8.33009 12.3304 8.42464C12.4657 8.51919 12.5144 8.66294 12.4766 8.85589C12.299 9.83921 11.8206 10.6507 11.0415 11.2905C10.2623 11.9302 9.36442 12.2501 8.34777 12.2501Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_872_7588",
    x1: 8.33337,
    y1: 0,
    x2: 8.33337,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#687EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3733FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "night.2d7a7954a930bd62a816b0dd972d4c77.svg";